import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import { connect } from 'react-redux';
import { getTotalForReceipt } from '../selectors';
import { clearPayingObject } from '../../../main/payment/actions';
import { hideReceipt } from '../actions';
import ReceiptSent from '../components/ReceiptSent';

const TWO_SECONDS = 2000;
let timeout = null;
const ReceiptSentContainer = compose(
  connect(
    (state, ownProps) => ({
      type: ownProps.params.type,
      total: getTotalForReceipt(state),
    }),
    { hideReceipt, clearPayingObject },
  ),
  withHandlers({
    closeReceipt: props => () => {
      props.hideReceipt();
      return props.clearPayingObject();
    },
  }),
  lifecycle({
    componentDidMount() {
      timeout = setTimeout(() => this.props.closeReceipt(), TWO_SECONDS);
    },
    componentWillUnmount() {
      clearTimeout(timeout);
    },
  }),
)(ReceiptSent);

export default ReceiptSentContainer;
